import styled from 'styled-components';

export const TagField = styled.p`
  margin: 0 0 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 160%;
  color: var(--color-text);
`;
